import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'vit-quick-tipp',
  templateUrl: './quick-tipp.component.html',
  styleUrls: ['./quick-tipp.component.scss']
})
export class QuickTippComponent implements OnInit {

  @Output() quickTippSelected: EventEmitter<number> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/betting/quick-tipp/quick-tipp.component.ts